/**
 * Public-demo banner (CLAUDE.md §2 — tag demo/sample data until live data flows). Renders a thin
 * gold strip ONLY in the no-login demo build (`VITE_DEMO=true`); in every other build
 * `import.meta.env.VITE_DEMO` is undefined and this renders nothing, so prod is visually unchanged.
 * Every figure behind the demo screens is synthetic, generated by routes/demo.ts → demo-backfill.ts.
 */
export function DemoBanner() {
  if (import.meta.env.VITE_DEMO !== 'true') return null;
  return (
    <div
      role="status"
      className="flex items-center justify-center gap-2 border-b border-gold/40 bg-gold/10 px-4 py-1.5 text-xs font-medium text-ink"
    >
      <span className="h-1.5 w-1.5 rounded-full bg-gold" aria-hidden />
      <span>
        Illustrative demo data — synthetic figures for demonstration only, not live Gold Fields
        operational data.
      </span>
    </div>
  );
}
